import { render, staticRenderFns } from "./descriptioncheck.vue?vue&type=template&id=4faf2e5f&scoped=true&lang=true"
import script from "./descriptioncheck.vue?vue&type=script&lang=js"
export * from "./descriptioncheck.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=4faf2e5f&prod&lang=scss&scoped=true&external"
import style1 from "./descriptioncheck.vue?vue&type=style&index=1&id=4faf2e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf2e5f",
  null
  
)

export default component.exports